import types from "./types";
import API from "../../axios/physician/PhysicianApi";
import handleAPIErrorResponse from "../../utils/handleAPIResponseError";

const setOneClickPrescribeQueueLoading = (status) => ({
    type: types.SET_ONE_CLICK_PRESCRIBE_QUEUE_LOADING,
    data: status,
});

const setOneClickPrescribeQueue = cases => ({
    type: types.SET_ONE_CLICK_PRESCRIBE_QUEUE,
    data: cases
})

const removeOneClickPrescribeCaseFromQueue = caseId => ({
    type: types.REMOVE_ONE_CLICK_PRESCRIBE_CASE_FROM_QUEUE,
    data: caseId
})

const markOneClickPrescribeCaseSuccessful = caseId => ({
    type: types.MARK_ONE_CLICK_PRESCRIBE_CASE_SUCCESSFUL,
    data: caseId
})

const acknowledgeFlaggedCase = caseId => ({
    type: types.ACKNOWLEDGE_FLAGGED_CASE,
    data: caseId
})

function getOneClickPrescribeQueue(params) {
    return (dispatch) => {
        dispatch(setOneClickPrescribeQueue({}))
        dispatch(setOneClickPrescribeQueueLoading(true));
        API.getOneClickPrescribeEligibleCases(params)
            .then((res) => {
                if (!res.data?.success) throw Error()
                dispatch(setOneClickPrescribeQueue(res.data.payload || {}))
            })
            .catch(error => handleAPIErrorResponse(error, "Unable to fetch Clinical Eligibility Validator eligible cases"))
            .finally(() => dispatch(setOneClickPrescribeQueueLoading(false)))
    };
}

function addCaseToOneClickPrescribeQueue(_case) {
    return dispatch => {
        dispatch({
            type: types.ADD_CASE_TO_ONE_CLICK_PRESCRIBE_QUEUE,
            data: _case
        })
    }
}

const actions = {
    getOneClickPrescribeQueue,
    removeOneClickPrescribeCaseFromQueue,
    addCaseToOneClickPrescribeQueue,
    markOneClickPrescribeCaseSuccessful,
    acknowledgeFlaggedCase,
};

export default actions;

